function Log (...params) {
  if (process.env.VUE_APP_ENV === 'production') return
  console.log(...params)
}

export default Log
